let _isProd: boolean | undefined;

export function isProd() {
  if (_isProd === undefined) {
    const env$ = document.head.querySelector(`meta[name='env']`);

    _isProd = env$?.getAttribute('content') === 'production';
  }

  return _isProd;
}
